/**
 * Routes that render MarketingSiteHeader as the only top bar.
 * AppLayout must not show the app Navigation on these paths (avoids double headers when logged in).
 */
export function isMarketingStandaloneNavPath(pathname: string): boolean {
  if (pathname === '/resources' || pathname.startsWith('/resources/')) return true;
  if (pathname === '/blog') return true;
  if (pathname.startsWith('/blog/')) return true;
  return false;
}

/**
 * Public marketing pages where app-shell navigation should be hidden.
 * These routes should feel like the website, not the authenticated app shell.
 */
export function isMarketingPublicPath(pathname: string): boolean {
  if (isMarketingStandaloneNavPath(pathname)) return true;

  const exactRoutes = new Set([
    '/guides',
    '/press',
    '/photo-credits',
    '/about',
    '/support',
    '/faq',
    '/contact',
    '/pricing',
    '/business-inquiries',
    '/site-map',
    '/best-relationship-app',
    '/best-couples-app',
    '/relationship-counseling-app',
    '/ai-couples-therapy',
    '/early-access',
  ]);

  if (exactRoutes.has(pathname)) return true;

  return (
    pathname.startsWith('/features/') ||
    pathname.startsWith('/compare/') ||
    pathname.startsWith('/alternatives/')
  );
}
